'use client';

import PropTypes from 'prop-types';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';
import { useAnalytics } from '~/contexts/AnalyticsContext.tsx';

export default function CreateAccountLink({ href }) {
  const { reaa } = useAnalytics();
  return (
    <Button href={href} textButton onClick={() => reaa('signin_event', 'create_account_click', {})}>
      <strong>create your account here</strong>
    </Button>
  );
}

CreateAccountLink.propTypes = {
  href: PropTypes.string.isRequired,
};
